import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const OutsourcedBookkeepingPayroll = () => {
  const serviceData = {
    title: "Outsourced Bookkeeping",
    heading: "Outsourced Bookkeeping",
    image: subTopicImages["Outsourced Bookkeeping"],
    intro: "Accurate accounting records form the backbone of every business.",
    description: [
      "We manage the complete accounting cycle so your financial data remains organised, reliable and audit-ready.",
    ],
    services: [
      {
        title: "Outsourced Bookkeeping Services",
        text: "Our support covers:",
        list: [
          "recording day-to-day transactions and journal entries",
          "managing vendor and customer ledgers",
          "bank, inter-company and balance-sheet reconciliations",
          "accounts payable and receivable tracking",
          "month-end closing and ledger reviews",
          "maintenance of statutory / accounting books",
        ],
        extraInfo:
          "We follow structured review controls to ensure that your accounting data remains accurate, compliant and ready for audits, reporting and regulatory review.",
      },
    ],
    benefitsIntro: "This service is ideal for:",
    benefits: [
      "businesses that want professional accounting oversight without hiring a full internal team",
    ],
    research: "",
  };
  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default OutsourcedBookkeepingPayroll;
